export default __webpack_public_path__ + "static/besteArbeitgeberDeutschland-96e7001c02d2b86047ae44ae367d6fa3.png";